import React from "react";
import Login from "../components/Auth/Login";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";

const LoginPage = () => {
  return (
    <>
      <PublicHeader />
      <Login />
      <Footer />
    </>
  );
};

export default LoginPage;
